"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditValidationResultDtoDecisionEnum = exports.DocumentAuditValidationResultDtoSourceEnum = void 0;
exports.instanceOfDocumentAuditValidationResultDto = instanceOfDocumentAuditValidationResultDto;
exports.DocumentAuditValidationResultDtoFromJSON = DocumentAuditValidationResultDtoFromJSON;
exports.DocumentAuditValidationResultDtoFromJSONTyped = DocumentAuditValidationResultDtoFromJSONTyped;
exports.DocumentAuditValidationResultDtoToJSON = DocumentAuditValidationResultDtoToJSON;
exports.DocumentAuditValidationResultDtoToJSONTyped = DocumentAuditValidationResultDtoToJSONTyped;
const DocumentAuditUploadedByDto_1 = require("./DocumentAuditUploadedByDto");
const DocumentAuditValidationComparisonsDto_1 = require("./DocumentAuditValidationComparisonsDto");
/**
 * @export
 */
exports.DocumentAuditValidationResultDtoSourceEnum = {
    Llm: 'LLM',
    Human: 'HUMAN',
};
/**
 * @export
 */
exports.DocumentAuditValidationResultDtoDecisionEnum = {
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
};
/**
 * Check if a given object implements the DocumentAuditValidationResultDto interface.
 */
function instanceOfDocumentAuditValidationResultDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    if (!('decision' in value) || value['decision'] === undefined)
        return false;
    if (!('notes' in value) || value['notes'] === undefined)
        return false;
    if (!('nurseEmailMessage' in value) ||
        value['nurseEmailMessage'] === undefined)
        return false;
    if (!('reviewedBy' in value) || value['reviewedBy'] === undefined)
        return false;
    if (!('comparisons' in value) || value['comparisons'] === undefined)
        return false;
    return true;
}
function DocumentAuditValidationResultDtoFromJSON(json) {
    return DocumentAuditValidationResultDtoFromJSONTyped(json, false);
}
function DocumentAuditValidationResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        createdAt: new Date(json['createdAt']),
        source: json['source'],
        decision: json['decision'],
        notes: json['notes'],
        nurseEmailMessage: json['nurseEmailMessage'],
        reviewedBy: (0, DocumentAuditUploadedByDto_1.DocumentAuditUploadedByDtoFromJSON)(json['reviewedBy']),
        comparisons: (0, DocumentAuditValidationComparisonsDto_1.DocumentAuditValidationComparisonsDtoFromJSON)(json['comparisons']),
    };
}
function DocumentAuditValidationResultDtoToJSON(json) {
    return DocumentAuditValidationResultDtoToJSONTyped(json, false);
}
function DocumentAuditValidationResultDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        createdAt: value['createdAt'].toISOString(),
        source: value['source'],
        decision: value['decision'],
        notes: value['notes'],
        nurseEmailMessage: value['nurseEmailMessage'],
        reviewedBy: (0, DocumentAuditUploadedByDto_1.DocumentAuditUploadedByDtoToJSON)(value['reviewedBy']),
        comparisons: (0, DocumentAuditValidationComparisonsDto_1.DocumentAuditValidationComparisonsDtoToJSON)(value['comparisons']),
    };
}
//# sourceMappingURL=DocumentAuditValidationResultDto.js.map